import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ProjectMember } from './models';

export interface LoadingStatus {
    serverRequestInProgress: boolean;
    loaded: boolean;
}

export interface State extends EntityState<ProjectMember>, LoadingStatus {}

export const adapter: EntityAdapter<ProjectMember> = createEntityAdapter<ProjectMember>();

export const initialState: State = adapter.getInitialState({
    serverRequestInProgress: false,
    loaded: false,
});
